import { OrderRegularMedicationsProvider } from '../OrderRegularMedicationsContext';

interface IDialogOrderRegularMedications {
  open: boolean;
  handleClose: () => void;
  openSuccessOrderDialog: () => void;

  setSuccessOrderDialogExpiredPrescriptions: React.Dispatch<
    React.SetStateAction<string[] | undefined>
  >;
}

export const DialogOrderRegularMedications = (
  props: IDialogOrderRegularMedications
) => {
  const {
    handleClose,
    open,
    openSuccessOrderDialog,
    setSuccessOrderDialogExpiredPrescriptions,
  } = props;

  return (
    <OrderRegularMedicationsProvider
      handleClose={handleClose}
      open={open}
      openSuccessOrderDialog={openSuccessOrderDialog}
      setSuccessOrderDialogExpiredPrescriptions={
        setSuccessOrderDialogExpiredPrescriptions
      }
    />
  );
};
